import { useRef, useState } from "react";

/**
 * Ein Wert zum Kopieren (`pf-copy`): schreibgeschütztes Feld, daneben
 * „Kopieren". Ohne Zwischenablage (kein https, verweigert) wird der Text
 * markiert, damit Strg+C reicht.
 */
export function CopyField({ value, button = true, onCopied }: { value: string; button?: boolean; onCopied?: () => void }) {
  const [copied, setCopied] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      onCopied?.();
    } catch {
      inputRef.current?.select();
    }
  };
  return (
    <div className="pf-copy">
      <input ref={inputRef} className="pf-input" readOnly value={value} />
      {button && <button type="button" className="pf-btn pf-btn--sm" onClick={(e) => { e.preventDefault(); void copy(); }}>{copied ? "Kopiert" : "Kopieren"}</button>}
    </div>
  );
}
